import styled from 'styled-components';
import { Box } from '@mui/material';
import { ToastContainer } from 'react-toastify';

const Container = styled(Box)`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const MainBox = styled(Box)`
  flex: 1;
  /*
    Right panel is position:fixed, so it does not participate in flex layout.
    Reserve space inside the main area via padding so content doesn't render under it,
    while still letting flexbox handle the left sidebar width.
  */
  padding-right: ${({ $rightMargin }) => `${$rightMargin || 0}px`};
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: padding-right 0.2s ease-out;
`;

const ContentBox = styled(Box)`
  flex: 1;
  width: 100%;
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
`;

const StyledToastContainer = styled(ToastContainer).attrs({
  className: 'toast-container',
})`
  min-width: 25%;
`;

export {
  Container,
  MainBox,
  ContentBox,
  StyledToastContainer,
};
